import { Header } from "@/components/Header";
import { ChangePasswordForm } from "@/components/auth/ChangePasswordForm";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container mx-auto py-6">
        <div className="max-w-md mx-auto">
          <h1 className="text-2xl font-bold mb-6">Change Password</h1>
          <ChangePasswordForm onSuccess={() => navigate("/")} />
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;